export default __webpack_public_path__ + "static/media/reparatie.47876c59.svg";